// Lønn og ansatte (en).
window.PlummeI18n.register('en', {
  // ------------------------------------------------ Payroll and employees
  'pay.personalia': 'Personal details',
  'pay.personalInfo': 'Personal information',
  'pay.edit': 'Edit',
  'pay.documents': 'Documents',
  'pay.description': 'Description',
  'pay.contract': 'Employment contract',
  'pay.open': 'Open',
  'pay.download': 'Download',
  'pay.delete': 'Delete',
  'pay.employment': 'Employment',
  'pay.positionAndAgreement': 'Position and agreement',
  'pay.searchOccupationCodes': 'Search occupation codes ...',
  'pay.cancel': 'Cancel',
  'pay.saveEmployment': 'Save employment',
  'pay.employmentFrom': 'Employment valid from',
  'pay.employmentFromHint': 'The date the employee had, or will have, their first working day at your business. This date is independent of when you started bookkeeping in Plumme.',
  'pay.endDate': 'End date',
  'pay.endDateHint': 'Leave the field empty while the employment is still open.',
  'pay.occupationCode': 'Occupation code',
  'pay.occupationCodeHint': 'Search the public registry of occupation codes and choose the best match. The field is used for statistics on occupations in Norway.',
  'pay.employmentType': 'Employment relationship type',
  'pay.employmentForm': 'Form of employment',
  'pay.workingHoursScheme': 'Working hours scheme',
  'pay.workingHoursSchemeHint': 'Most employees are Not shift work, but some will fall under the other categories.',
  'pay.hoursFullWeek': 'Hours for a full week',
  'pay.hoursFullWeekHint': 'Number of working hours in a full week if the employee works 100%. Usually 37.5 hours.',
  'pay.salaryType': 'Salary type',
  'pay.hourlyPay': 'Hourly pay',
  'pay.fixedPay': 'Fixed salary',
  'pay.ftePercent': 'FTE percentage',
  'pay.ftePercentHint': 'Choose an estimated FTE percentage. If unsure, use the nearest percentage.',
  'pay.fullTime': 'Full-time',
  'pay.partTime': 'Part-time',
  'pay.employmentScope': 'Employment scope',
  'pay.adjustHoursBy': 'Adjust hours by',
  'pay.perWeek': 'Per week',
  'pay.perMonth': 'Per month',
  'pay.hoursPerWeek': 'Hours per week',
  'pay.hoursPerMonth': 'Hours per month',
  'pay.otherEntityNumber': 'Other entity number',
  'pay.optionalEntityNumber': 'Optional entity number',
  'pay.priorPayOutsidePlumme': 'Earlier salary outside Plumme paid by your business',
  'pay.priorPayHelp': 'Only enter salary that is not registered in Plumme but has been paid by the business.',
  'pay.warning': 'Warning:',
  'pay.forPublicStatistics': 'For public statistics - fill in only if relevant',
  'pay.lastAdjustmentDate': 'Date of last salary adjustment',
  'pay.salaryGrade': 'Salary grade',
  'pay.salaryGradePh': 'E.g. 45',
  'pay.agreedSalary': 'Agreed salary',
  'pay.save': 'Save',
  'pay.annualSalary': 'Annual salary',
  'pay.agreementTaxHeading': 'Agreement, holiday pay, tax and employer\'s contribution',
  'pay.tax': 'Tax',
  'pay.notFetchedFromAltinn': 'Not fetched from Altinn',
  'pay.salaryPerYear': 'Salary per year',
  'pay.holidayPay': 'Holiday pay',
  'pay.employerContribution': 'Employer\'s national insurance contribution',
  'pay.estimatedTax': 'Estimated tax',
  'pay.estimatedAnnualCost': 'Estimated annual cost',
  'pay.noAgreedSalary': 'No agreed salary has been entered',
  'pay.taxCard': 'Tax card',
  'pay.taxCardHelp': 'Tax cards are not fetched yet. This will be connected once the Skatteetaten integration is ready.',
  'pay.fixedLines': 'Recurring lines',
  'pay.fixedLinesHelp': 'Salary lines that are normally included in every payment.',
  'pay.newFixedLine': 'Create a new recurring line',
  'pay.seeFixedLines': 'View recurring salary lines',
  'pay.payslips': 'Payslips',
  'pay.noPayslips': 'No payslips have been created yet.',
  'pay.gross': 'Gross',
  'pay.paidOut': 'Paid out',
  'pay.employeePortal': 'Employee portal',
  'pay.employeePortalSub': 'Payslips, travel and expenses for the employee.',
  'pay.needEmailFirst': 'Enter a valid email address on the employee profile before granting access.',
  'pay.goToTravelExpenses': 'Go to travel and expenses',
  'pay.saveEmployee': 'Save employee',
  'pay.nationalId': 'National identity number',
  'pay.hasInternationalId': 'Has an international ID',
  'pay.name': 'Name',
  'pay.phone': 'Phone number',
  'pay.email': 'Email',
  'pay.address': 'Address',
  'pay.country': 'Country',
  'pay.address1': 'Address 1',
  'pay.streetAddress': 'Street address',
  'pay.address2': 'Address 2',
  'pay.optional': 'Optional',
  'pay.postalCode': 'Postal code',
  'pay.postalPlace': 'Postal place',
  'pay.postalPlacePh': 'Postal place ...',
  'pay.accountNumber': 'Account number',
  'pay.hasForeignAccount': 'Has a foreign account number',
  'pay.mainOrSecondaryEmployer': 'Secondary/main employer',
  'pay.taxAndDutyRules': 'Tax and duty rules',
  'pay.noteOptional': 'Note (optional)',
  'pay.notePh': 'Write a note ...',
  'pay.employees': 'Employees',
  'pay.employeesHelp': 'The register of everyone employed by the business. Tap an employee to see personal details, employment, salary and payslips.',
  'pay.allEmployees': 'All employees in your business',
  'pay.newEmployee': 'New employee',
  'pay.newEmployeeHelp': 'Register a new employee with personal details, employment and salary terms. The employee is then included in payroll runs and the A-melding.',
  'pay.noEmployees': 'No employees yet',
  'pay.salaryTypeLabel': 'Salary type:',
  'pay.status': 'Status',
  'pay.statusHelp': 'An active employment means the employee is included in payroll runs. Ended means the employment has ceased.',
  'pay.payroll': 'Payroll',
  'pay.payrollSub': 'Run payroll, follow up employees, periods and holiday pay.',
  'pay.payrollModuleHelp': 'The payroll module gathers everything about employees and pay: running payroll, employer\'s contribution and withholding tax, pension (OTP), holiday pay, travel and expenses, and settings. Switch between the subpages in the dropdown menu.',
  'pay.payrollPages': 'Payroll pages',
  'pay.payrollPagesHelp': 'Switch between the payroll sub-pages — Employees, Payroll run, Employer\'s contribution and tax, Pension/OTP, Recurring salary lines, Travel and expenses, Payroll overview, Holiday pay list, Payroll settings and Salary types.',
  'pay.employmentStatus': 'Employment status',
  'pay.employmentStatusHelp': 'Shows whether the employment is active or ended. Active employees are included in payroll runs and reported in the A-melding.',
  'pay.backToPayrollRun': 'Back to the payroll run',
  'pay.showAllEmployees': 'Show all employees',
  'pay.yourEmployers': 'Your employers',
  'pay.yourClients': 'Your clients',
  'pay.bgForEmployer': 'Background colour for this employer',
  'pay.bgColour': 'Background colour',
  'pay.receiptHelp': 'Take a photo, upload, drag in or paste. Expenses without a receipt cannot be submitted.',
  'pay.takePhoto': 'Take a photo',
  'pay.uploadFile': 'Upload image/file',
  'pay.remove': 'Remove',
  'pay.registerExpense': 'Register expense',
  'pay.receiptRequired': 'A receipt is required',
  'pay.category': 'Category',
  'pay.pickCategory': 'Choose category',
  'pay.date': 'Date',
  'pay.paidWith': 'Paid with',
  'pay.privateExpense': 'Private expense',
  'pay.companyCard': 'Company card/operating account',
  'pay.amount': 'Amount',
  'pay.currency': 'Currency',
  'pay.whatIsExpenseFor': 'What is the expense for?',
  'pay.registerTravel': 'Register travel',
  'pay.sentForApproval': 'Sent for approval',
  'pay.dateFrom': 'Date from',
  'pay.dateTo': 'Date to',
  'pay.travelType': 'Travel type',
  'pay.travelWithExpenses': 'Travel with expenses/driving',
  'pay.drivingOnly': 'Driving only',
  'pay.travelWithSubsistence': 'Travel with subsistence allowance',
  'pay.destination': 'Destination',
  'pay.destinationPh': 'City, customer or place',
  'pay.from': 'From',
  'pay.startPlace': 'Starting point',
  'pay.to': 'To',
  'pay.endPlace': 'Destination',
  'pay.kilometres': 'Kilometres',
  'pay.purpose': 'Purpose',
  'pay.purposeHelp': 'What was the purpose of the trip?',
  'pay.note': 'Note',
  'pay.createTravelClaim': 'Create travel expense claim',
  'pay.purposePh': 'E.g. customer meeting in Drammen',
  'pay.whereDidYouGo': 'Where did the trip go?',
  'pay.norway': 'Norway',
  'pay.tolls': 'Tolls',
  'pay.tollsPaidWith': 'Tolls paid with',
  'pay.fromDate': 'From date',
  'pay.toDate': 'To date',
  'pay.type': 'Type',
  'pay.hotel': 'Hotel',
  'pay.otherAccommodation': 'Other accommodation',
  'pay.guesthouse': 'Guesthouse or barracks',
  'pay.place': 'Place',
  'pay.hotelOrPlace': 'Hotel or place',
  'pay.travelClaim': 'Travel expense claim',
  'pay.rejectedByEmployer': 'Rejected by the employer',
  'pay.newAccommodation': 'New accommodation',
  'pay.newTrip': 'New trip',
  'pay.newExpense': 'New expense',
  'pay.noLinesYet': 'No lines yet',
  'pay.employee': 'Employee',
  'pay.subsistence': 'Subsistence allowance',
  'pay.payslip': 'Payslip',
  'pay.close': 'Close',
  'pay.netPaid': 'Net paid',
  'pay.period': 'Period',
  'pay.payAndDeductions': 'Pay and deductions',
  'pay.grossPay': 'Gross pay',
  'pay.withholdingTax': 'Withholding tax',
  'pay.expenseRefund': 'Refund of expenses/travel',
  'pay.payslipPdfNote': 'PDF view and sending will be connected when the payslip generator is exposed in Plumme.',
  'pay.noPayslipsYet': 'No payslips yet.',
  'pay.myExpenses': 'My expenses',
  'pay.noExpensesInView': 'No expenses in this view.',
  'pay.expenses': 'Expenses',
  'pay.preview': 'Preview',
  'pay.loadingReceipt': 'Loading receipt...',
  'pay.canStillDownload': 'The receipt can still be downloaded manually.',
  'pay.cannotPreview': 'This file type cannot be previewed here.',
  'pay.openNewTab': 'Open in a new tab',
  'pay.myTravel': 'My travel',
  'pay.noTravelInView': 'No travel in this view.',
  'pay.fetchingPortal': 'Fetching the employee portal',
  'pay.portalFailed': 'Could not fetch the employee portal',
  'pay.back': 'Back',
  'pay.noEmployers': 'No employers',
  'pay.home': 'Home',
  'pay.homeHelp': 'Your employee page with the selected employer — payslips, expenses and travel.',
  'pay.myPage': 'My page',
  'pay.myPageHelp': 'Your personal account in Plumme — profile, businesses and personal finances.',
  'pay.signOut': 'Sign out',
  'pay.paidByCompanyHint': 'The receipt goes to bookkeeping, not to reimbursement.',
  'pay.paidPrivateHint': 'You get the amount reimbursed with your pay.',
  'pay.expenseProject': 'Project',
  'pay.expenseProjectHint': 'An expense on a project can be rebilled to the customer.',
  'pay.expenseNoProject': 'Not on a project',
  'pay.myHours': 'My hours',
  'pay.hoursThisMonth': '{time} this month',
  'pay.hoursHelp': 'The hours you have logged on projects for this employer.',
  'pay.registerHours': 'Log hours',
  'pay.timeNew': 'Log hours',
  'pay.timeEdit': 'Edit entry',
  'pay.timeDate': 'Date',
  'pay.timeProject': 'Project',
  'pay.timeActivity': 'Activity',
  'pay.timeHours': 'Hours',
  'pay.timeNote': 'Note',
  'pay.timeNotePh': 'What did you work on?',
  'pay.timePickProject': 'Choose project …',
  'pay.timePickActivity': 'Choose activity …',
  'pay.timeSum': 'Total',
  'pay.timeSaved': 'The entry was saved',
  'pay.timeDeleted': 'The entry was deleted',
  'pay.timeFailed': 'Could not save the entry.',
  'pay.timeLocked': 'Time tracking for this period is marked as finished.',
  'pay.timeLockedThrough': 'Time tracking is marked as finished through {date}.',
  'pay.timeEmptyTitle': 'No hours this week',
  'pay.timeEmpty': 'Press "Log hours" to add the first one.',
  'pay.timeNoProjectsTitle': 'No projects',
  'pay.timeNoProjects': 'Your employer has not created any projects you can log hours on yet.',
  'pay.timePrevWeek': 'Previous week',
  'pay.timeNextWeek': 'Next week',
  'pay.myEmployeePage': 'My employee page',
  'pay.myEmployeePageHelp': 'Your page as an employee with an employer — separate from any accounts you keep. Here you see your payslips, and you register expenses and travel you are owed for. At the top you switch between the employers you work for.',
  'pay.employer': 'Employer',
  'pay.employerHelp': 'The employer this page applies to. If you are employed in several places, you switch here — then payslips, expenses and travel show the figures for the selected employer.',
  'pay.payslipsHelp': 'The payslips from the employer — an overview of pay, tax withheld and net pay for each pay run. Tap to open.',
  'pay.expensesHelp': 'Expenses you have paid out of your own pocket and are to be refunded for — for example a receipt bought privately. Submit them for approval, and they are refunded through payroll.',
  'pay.travelHelp': 'Travel claims with mileage allowance, subsistence and expenses linked to a trip. Submit them for approval and refund through payroll.',
  'pay.registerExpenseHelp': 'Register a new expense you have paid out for — upload the receipt, enter the amount and what it is for. It is sent to the employer for approval and refund.',
  'pay.registerTravelHelp': 'Register a travel claim — trips (mileage allowance), subsistence and expenses linked to the trip. It is sent to the employer for approval.',

  // Employment status, special tax rules and foreign-currency expenses (2026-09-27).
  'pay.employmentStatusLabel.active': 'Active employment',
  'pay.employmentStatusLabel.ended': 'Left',
  'pay.employmentStatusLabel.future': 'Starts later',
  'pay.taxRuleNotSupported': 'not supported yet',
  'pay.taxRuleNotSupportedHint': 'Plumme only calculates ordinary tax and employer contribution. A payroll run with this employee cannot be approved – run payroll for this employee outside Plumme.',
  'pay.portalEmploymentEnded': 'Your employment has ended. You can still see your payslips, but you cannot submit new expenses, travel claims or hours. Contact your employer if you have an expense to be refunded.',
  'err.employeePortal.employmentEnded': 'The employment has ended and the employee portal is now read-only. Ask the employer to register the expense.',
  'pay.foreignAmount.label': 'Amount paid in NOK',
  'pay.foreignAmount.hint': 'The receipt is in {currency}. Enter what you actually paid in Norwegian kroner, for example from your bank statement. The expense cannot be approved without a NOK amount.',
  'pay.foreignAmount.rateHint': 'Equals a rate of {rate} NOK per {currency}.',
  'pay.foreignAmount.missing': 'NOK amount missing',
  'pay.foreignAmount.missingOnApproval': 'The expense "{description}" is in {currency} and has no NOK amount. Edit the line and enter the amount actually paid in NOK before approving.',
  'err.payroll.foreignAmountMissingNok': 'An expense in a foreign currency has no NOK amount. Enter the amount actually paid in NOK before approving.',

  // Lonn.jsx i18n batch 1 (2026-09-29).
  'pay.tabSalaryTax': 'Salary & tax',
  'pay.tabPayslipsExpenses': 'Payslips & expenses',
  'pay.taxRuleOption.ordinary': 'Ordinary',
  'pay.taxRuleOption.svalbard': 'Svalbard',
  'pay.taxRuleOption.janMayen': 'Jan Mayen and the dependencies',
  'pay.taxRuleOption.seafarerDeduction': 'Special deduction for seafarers',
  'pay.taxRuleOption.charity': 'Charitable or non-profit organization',
  'pay.taxRuleOption.netPay': 'Net pay',
  'pay.taxRuleOption.netPaySeafarer': 'Net pay for seafarers',
  'pay.taxRuleOption.pensionSourceTax': 'Withholding tax on pensions',
  'pay.taxRuleOption.nanny': 'Nanny in the child\'s home',
  'pay.taxRuleOption.homeWork': 'Paid work in the home',
  'pay.taxRuleOption.taxFreeOrg': 'Tax-exempt organization',
  'pay.employmentTypeOption.ordinary': 'Ordinary employment',
  'pay.employmentTypeOption.maritime': 'Maritime employment',
  'pay.employmentTypeOption.freelance': 'Freelancer, contractor or fee recipient',
  'pay.employmentTypeOption.pension': 'Pension or other tax-liable relationship',
  'pay.employmentTypeOption.notEmployed': 'Not employed',
  'pay.employmentTypeOption.simplifiedPrivate': 'Simplified settlement scheme, private employer',
  'pay.employmentTypeOption.simplifiedCharity': 'Simplified settlement scheme, charitable organization',
  'pay.employmentTypeOption.foreignService': 'Foreign service relationship',
  'pay.employmentTypeOption.boardFee': 'Board fee',
  'pay.employmentFormOption.permanent': 'Permanent',
  'pay.employmentFormOption.temporary': 'Temporary',
  'pay.employmentFormOption.temporarySubstitute': 'Temporary on-call substitute',
  'pay.employmentFormOption.permanentHiredOut': 'Permanent employment, hired out',
  'pay.employmentFormOption.temporaryHiredOut': 'Temporary employment, hired out',
  'pay.shift.offshore': 'Offshore',
  'pay.hourlyOvertimePay': 'Hourly pay - overtime',
  'pay.fixedLine': 'Fixed line',
  'pay.portalAccess.notInvited': 'Not granted access',
  'pay.portalAccess.active': 'Active access',
  'pay.portalAccess.revoked': 'Access revoked',
  'pay.documentUploaded': 'Document uploaded.',
  'pay.documentsUploaded': 'Documents uploaded.',
  'pay.documentDeleted': 'Document deleted.',
  'pay.amountRequired': 'Enter an amount.',
  'pay.fixedLineDeleted': 'Fixed salary line deleted.',
  'pay.fixedLineDeleteFailed': 'Could not delete fixed salary line.',
  'pay.emailRequiredFirst': 'Enter a valid email address on the employee profile first.',
  'pay.portalAccessSent': 'Access sent to {email}.',
  'pay.portalAccessRevokedToast': 'Access revoked.',
  'pay.portalAccessSendFailed': 'Could not send access.',
  'pay.portalAccessRevokeFailed': 'Could not revoke access.',
  'pay.saveEmployeeFailed': 'Could not save employee.',
  'pay.confirmDeleteDocument': 'Delete the document "{name}"?',
  'pay.confirmDeleteFixedLine': 'Delete fixed salary line "{line}" for {name}?',
  'pay.confirmRevokePortalAccess': 'Revoke employee portal access for {name}?',
  'pay.taxCardValidUntil': 'Tax card valid until',
  'pay.leaveOfAbsence': 'Leaves of absence',
  'pay.noLeaveRegistered': 'None registered',
  'pay.loginEmail': 'Login email',
  'pay.lastSent': 'Last sent',
  'pay.revoked': 'Revoked',
  'pay.bankAccount': 'Bank account',
  'pay.hoursInFullWeek': 'Hours in a full week',
  'pay.uploading': 'Uploading ...',
  'pay.newDocument': 'New document',
  'pay.resendAccess': 'Resend access',
  'pay.grantEmployeeAccess': 'Grant employee access',
  'pay.revoking': 'Revoking ...',
  'pay.revokeAccess': 'Revoke access',
  'pay.portalAccessExplain': 'Access is linked to the employee\'s email and employee ID. The employee surface itself uses this link when portal login is connected.',
  'pay.useStandardHolidayRate': 'Use the standard rate from payroll settings ({rate} %)',
  'pay.priorYearSalaryHeading': 'Pay in {year}',
  'pay.payrollDataHidden': 'Payroll data is hidden for this access',
  'pay.payrollDataHiddenBody': 'Employees, fixed salary lines and payroll runs live in a separate personnel document. Your role on this client is {role}, and the app was not able to read the personnel document. Travel and expenses posted as accounting can therefore still be shown.',
  'pay.unknownAccess': 'unknown access',
  'pay.readAccess': 'Read access',
  'pay.registerFirstEmployee': 'Register your first employee to use payroll runs, tax cards and the a-melding.',
  'pay.mainEmployerOption': 'Primary employer',
  'pay.secondaryEmployerOption': 'Secondary employer',
  'pay.documentsCount': '{count} documents',
  'pay.noDocumentsUploaded': 'No documents uploaded',
  'pay.cannotOpenDocument': 'Could not open document.',
  'pay.cannotDownloadDocument': 'Could not download document.',
  'pay.endEmployment': 'End employment',
  'pay.reopenEmployment': 'Reopen employment',
  'pay.earnedHolidayPayInYear': 'Holiday pay earned in {year}',
  'pay.holidayPayNotPaidBeforeStartHint': 'Holiday pay that had not been paid out before the start date in Plumme.',
  'pay.earnedTaxablePayInYear': 'Taxable pay earned in {year}',
  'pay.grossPayNotInPlummeHint': 'Gross pay paid out by the company in {year} that is not recorded in Plumme.',
  'pay.withheldTaxInYear': 'Tax withheld in {year}',
  'pay.priorYearAmountWarning': 'Amounts for {year} should only be filled in if they are not included in other payroll runs recorded in Plumme.',
  'pay.agreedSalaryInternalNote': 'Agreed salary is only used as internal documentation. Payroll runs are driven by fixed or manual salary lines.',
  'pay.estimatedAnnualSalaryFrom': 'Estimated annual salary is calculated from {summary}',
  'pay.fixedLinesRegisteredCount': '{count} registered',
  'pay.fixedLinesOnEmployee': 'Fixed salary lines on this employee.',
  'pay.noFixedLinesRegistered': 'No fixed lines are registered yet.',
  'pay.internalDocumentationNote': 'This is internal documentation. Payroll runs use fixed salary lines or manual lines on the payroll run.',
  'pay.noAgreedSalaryBody': 'Enter an annual or hourly salary to see the estimated annual cost, holiday pay, employer contribution and tax.',
  'pay.selectOccupationCode': 'Select occupation code ...',
  'pay.noOccupationCodeMatch': 'No matches for "{query}".',
  'pay.editEmployeeTitle': 'Edit employee',
  'pay.newEmployeeTitle': 'New employee',
});

window.PlummeI18n.register('en', {
  "err.nativeValidation.payrollManualAMelding.1": "Manual a-melding registration requires Norwegian payroll.",
  "err.nativeValidation.payrollManualAMelding.2": "Manual submission must be explicitly confirmed.",
  "err.nativeValidation.payrollManualAMelding.3": "Valid report period, submission date and manual reference are required.",
  "err.nativeValidation.payrollManualAMelding.4": "Manual submission date must follow the report month and cannot be in the future.",
  "err.nativeValidation.payrollManualAMelding.5": "Confirm exactly the posted payroll runs in the report month.",
  "err.nativeValidation.payrollManualAMelding.6": "Manual report reference is already registered for this month.",
  "err.nativeValidation.pensionPremiumMutation.1": "Pension payment requires Norwegian NOK accounting.",
  "err.nativeValidation.pensionPremiumMutation.2": "Valid pension document and date are required.",
  "err.nativeValidation.pensionPremiumMutation.3": "This pension payment workflow supports verified 2026 zone I rates only.",
  "err.nativeValidation.pensionPremiumMutation.4": "Pension payment uses NOK bank account 1920.",
  "err.nativeValidation.pensionPremiumMutation.5": "Pension amounts must be finite non-negative cent amounts.",
  "err.nativeValidation.pensionPremiumMutation.6": "Pension payment cannot be recorded before its accounting date.",
  "err.nativeValidation.pensionPremiumMutation.7": "Pension posting identity is already reserved.",
  "err.nativeValidation.pensionPremiumMutation.8": "Pension numbering history is invalid.",
});
